// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditStepModal_modalOverlay__B616a {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .EditStepModal_modalContent__bXEVb {
    background-color: white;
    padding: 0;
    border-radius: 8px;
    width: 90%;
    max-width: 600px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;
  }
  
  .EditStepModal_modalHeader__0GEW0 {
    background-color: #007bff; /* Blue header */
    color: white;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .EditStepModal_modalTitle__rD6zO {
    margin: 0;
    font-size: 18px;
    font-weight: 500;
  }
  
  .EditStepModal_closeButton__fiDVz {
    background: none;
    border: none;
    color: white;
    font-size: 24px;
    cursor: pointer;
    line-height: 1;
  }
  
  .EditStepModal_modalBody__nqv30 {
    padding: 20px;
  }
  
  .EditStepModal_modalDescription__b04E\\+ {
    margin-bottom: 20px;
    color: #666;
    font-size: 14px;
  }
  
  .EditStepModal_optionsGrid__GSmqU {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  
  .EditStepModal_optionCard__cvarB {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    background-color: white;
  }
  
  .EditStepModal_optionCard__cvarB:hover {
    border-color: #007bff;
    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
  }
  
  .EditStepModal_optionIcon__\\+-w7Z {
    font-size: 24px;
    margin-bottom: 10px;
    color: #555;
  }
  
  .EditStepModal_optionLabel__g4eQ5 {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
  
  @media (max-width: 480px) {
    .EditStepModal_optionsGrid__GSmqU {
      grid-template-columns: 1fr;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/organism/EditStepModal.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB,EAAE,gBAAgB;IAC3C,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,4CAA4C;EAC9C;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE;MACE,0BAA0B;IAC5B;EACF","sourcesContent":[".modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  .modalContent {\n    background-color: white;\n    padding: 0;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 600px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .modalHeader {\n    background-color: #007bff; /* Blue header */\n    color: white;\n    padding: 15px 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .modalTitle {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 500;\n  }\n  \n  .closeButton {\n    background: none;\n    border: none;\n    color: white;\n    font-size: 24px;\n    cursor: pointer;\n    line-height: 1;\n  }\n  \n  .modalBody {\n    padding: 20px;\n  }\n  \n  .modalDescription {\n    margin-bottom: 20px;\n    color: #666;\n    font-size: 14px;\n  }\n  \n  .optionsGrid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 15px;\n  }\n  \n  .optionCard {\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    background-color: white;\n  }\n  \n  .optionCard:hover {\n    border-color: #007bff;\n    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);\n  }\n  \n  .optionIcon {\n    font-size: 24px;\n    margin-bottom: 10px;\n    color: #555;\n  }\n  \n  .optionLabel {\n    font-size: 14px;\n    color: #333;\n    font-weight: 500;\n  }\n  \n  @media (max-width: 480px) {\n    .optionsGrid {\n      grid-template-columns: 1fr;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `EditStepModal_modalOverlay__B616a`,
	"modalContent": `EditStepModal_modalContent__bXEVb`,
	"modalHeader": `EditStepModal_modalHeader__0GEW0`,
	"modalTitle": `EditStepModal_modalTitle__rD6zO`,
	"closeButton": `EditStepModal_closeButton__fiDVz`,
	"modalBody": `EditStepModal_modalBody__nqv30`,
	"modalDescription": `EditStepModal_modalDescription__b04E+`,
	"optionsGrid": `EditStepModal_optionsGrid__GSmqU`,
	"optionCard": `EditStepModal_optionCard__cvarB`,
	"optionIcon": `EditStepModal_optionIcon__+-w7Z`,
	"optionLabel": `EditStepModal_optionLabel__g4eQ5`
};
export default ___CSS_LOADER_EXPORT___;
